import React, { FC } from 'react';

import {
	CheckCircle,
	EV_SPINNER_SIZES,
	EvSpinner,
	EvSvgIcon,
	XCircle
} from '@evinced-private/ui-common';

import { isCrawlDone, isCrawlFailed } from '../../helpers/CrawlStateHelper';
import { ScanCrawlStateHelper } from '../../helpers/ScanCrawlStateHelper';
import { SCAN_STATE } from '../../interfaces/ScanState';
import { UrlSetState } from '../../interfaces/UrlSet';

interface IStatusIconProps {
	isScan: boolean;
	state?: SCAN_STATE | UrlSetState;
}

const StatusIcon: FC<IStatusIconProps> = ({ state, isScan }: IStatusIconProps) => {
	const isResultsReady = isScan
		? ScanCrawlStateHelper.isScanResultsReady(state as SCAN_STATE)
		: isCrawlDone(state as UrlSetState);

	const isFailed = isScan
		? ScanCrawlStateHelper.isFailed(state as SCAN_STATE)
		: isCrawlFailed(state as UrlSetState);

	const isLoading = !isResultsReady && !isFailed;

	const renderIcon = (): React.ReactNode => {
		if (isLoading) {
			return <EvSpinner size={EV_SPINNER_SIZES.XSMALL} />;
		}
		if (isResultsReady) {
			return <EvSvgIcon icon={CheckCircle} isSmall title="Done" />;
		}
		return <EvSvgIcon icon={XCircle} isSmall title="Failed" />;
	};

	return <div className="status">{renderIcon()}</div>;
};

export { StatusIcon };
